/** Alineado con backend: JWT cajero, id 5 o tipo "Cajero" en tipos_usuarios */
export function isCajeroUser(user) {
    if (!user) return false;
    if (user.cajero === true) return true;
    if (Number(user.role) === 5) return true;
    const name = String(user.role_name || '').trim().toLowerCase();
    return name === 'cajero';
}
